export default {
  home: {
    banner: {
      title: "Customer Stories",
      subtitle:
        "Authing provides cost-effective identity authentication and access management services for customers in different industries and countries, creating better experience for each service.",
    },
    example: {
      "heigh-educate": {
        title:
          "Higher Education Press - the way of transformation of traditional enterprises",
        subtitle:
          "Higher education press is a member of China Education Publishing Media Group Co., Ltd. It is a comprehensive large-scale publishing house which mainly publishes educational, professional and technological publications such as higher education, vocational education, adult and social education. This portal provides enterprise information, published books, digital products and courses, and teaching resources information.",

        label1: "education",
        label2: "B2C",
      },
    },
    cardList: {
      title: "Understand our customer story",
      item1: {
        title: "TOYOTA",
        text:
          "Toyota is one of the top ten auto companies in the world. It is the largest auto company in Japan. Founded in 1933, it has developed into a huge industrial group focusing on auto production and involving machinery, electronics, finance and other industries.",
        allText:
          "Toyota is one of the top ten auto companies in the world. It is the largest auto company in Japan. Founded in 1933, it has developed into a huge industrial group focusing on auto production and involving machinery, electronics, finance and other industries. Authing provides a unified identity security management platform for users and helps Toyota manage large-scale user growth.",
      },

      item2: {
        title: "China Merchants Bank",
        text:
          "China Merchants Bank, established in 1987, is the first joint-stock commercial bank in China to be wholly owned by an enterprise legal person. By the end of 2019, China Merchants Bank has a total market value of 939.9 billion yuan, ranking among the top ten in the global banking industry.",
        allText:
          "China Merchants Bank, established in 1987, is the first joint-stock commercial bank in China to be wholly owned by an enterprise legal person. By the end of 2019, China Merchants Bank has a total market value of 939.9 billion yuan, ranking among the top ten in the global banking industry. Authing helps China Merchants Bank improve its internal unified identity management ability, greatly reduce the operation and maintenance costs, and accelerate the business success.",
      },
      item3: {
        title: "Kingdee",
        text:
          "Kingdee International Software Group is a leading online management and e-commerce service provider in the world. Kingdee has provided services to 6.8 million enterprises and governments around the world through management software and cloud services.",
        allText:
          "Kingdee International Software Group is a leading online management and e-commerce service provider in the world. Kingdee has provided services to 6.8 million enterprises and governments around the world through management software and cloud services. Authing provides a unified identity authentication platform to help Kingdee manage user identity efficiently.",
      },
      item4: {
        title: "Southeast University",
        text:
          'Southeast University is a national key university directly under the Ministry of education, and one of the key construction universities of the national "985 Project" and "211 Project"',
        allText: `Southeast University is a national key university directly under the Ministry of education of the people's Republic of China. It is one of the key construction universities of the national "985 Project" and "211 Project". Through Authing, single sign on of cross platform user system is realized with only five lines of code.`,
      },
      item5: {
        title: "Bentley",
        text:
          "Bentley Engineering Software Co., Ltd., founded in 1984, employs more than 4000 people and has branches in 172 countries around the world, with an annual revenue of more than US $800 million. It is rated as the world's second largest provider of geographic information software solutions.",
        allText: "",
      },

      item6: {
        title: "EY",
        text:
          "EY (Ernst & Young) is one of the world's four largest accounting firms and one of the largest professional service organizations in Greater China. ",
        allText:
          "EY (Ernst & Young) is one of the world's four largest accounting firms and one of the largest professional service organizations in Greater China. It has provided professional services in the region for 40 years. During this period, Ernst & Young achieved a number of milestone developments: Ernst & Young’s predecessor, Yate Young, established its first office in Hong Kong in 1968; Ernst & Young became the first international professional service provider approved to conduct business in Mainland China in 1981. One of the institutions.",
      },
      item7: {
        title: "THERAGUN",
        text:
          "Theragun is also one of the best sports rehabilitation brands. It has been deeply cultivated in the field of percussive massage for nearly 10 years.",
        allText:
          "Theragun is also one of the best sports rehabilitation brands. It has been deeply cultivated in the field of percussive massage for nearly 10 years. Theragun is used by more than 250 professional sports teams around the world. Authing provides cloud identity security management services to solve the identity management problems of internal and external users.",
      },

      item8: {
        title: "PetroChina",
        text:
          "PetroChina is one of the key state-owned enterprises and one of the main oil and gas producers and suppliers in China, and it is the leading position in the domestic oil and gas exploration and development.",
        allText:
          "PetroChina is an important state-owned backbone enterprise and one of the main oil and gas producers and suppliers in China. It plays a leading role in domestic oil and gas exploration and development. Authing provides a perfect single sign on platform to help PetroChina quickly realize efficient user management.",
      },
      item9: {
        title: "Higher Education Society",
        text:
          "Founded in May 1954, higher education press is one of the earliest professional education publishing institutions in New China.",
        allText:
          "Founded in May 1954, higher education press is one of the earliest professional education publishing institutions in New China. Authing helps higher education press quickly integrate tens of millions of users to complete a comfortable and smooth login experience.",
      },
      item10: {
        title: "State Grid",
        text:
          "State Grid Co., Ltd., established in 2002, is a large state-owned key backbone enterprise related to the lifeline of national economy and national energy security.",
        allText:
          "State Grid Co., Ltd., established in 2002, is a large state-owned key backbone enterprise related to the lifeline of national economy and national energy security. By providing perfect identity management services, Authing helps State Grid to realize identity governance in an all-round way, enhance information security and strengthen risk control.",
      },

      item11: {
        title: "PingCap",
        text:
          "Founded in 2015, PingCAP is an enterprise-level open source distributed database vendor, providing open source distributed database products, solutions and consulting, technical support and training certification services, and is committed to providing stable, efficient, safe, reliable. ",
        allText:
          "Founded in 2015, PingCAP is an enterprise-level open source distributed database vendor, providing open source distributed database products, solutions and consulting, technical support and training certification services, and is committed to providing stable, efficient, safe, reliable, and open for global industry users Compatible new data infrastructure, liberating enterprise productivity, and accelerating enterprise digital transformation and upgrading.",
      },
      item12: {
        title: "JCDecaux Group",
        text:
          "JCDecaux group, founded in 1964, is the world's first international outdoor media company and listed in Euronext, Paris.",
        allText:
          "JCDecaux group, founded in 1964, is the No.1 international outdoor media company in the world and listed in Euronext in Paris. Authing helps enterprise users quickly access the enterprise internal application system to complete account synchronization, single sign on and access authorization.",
      },
      item13: {
        title: "Testin",
        text:
          "Testin founded in 2011, is an enterprise service platform driven by artificial intelligence technology. More than one million cloud developers around the world provide testing, testing, data tagging and security services.",
        allText:
          "Testin founded in 2011, is an enterprise service platform driven by artificial intelligence technology. More than one million cloud developers around the world provide testing, testing, data tagging and security services. The cloud identity security management service provided by Authing solves the pain points of multiple accounts, multiple passwords and multiple access.",
      },
      item14: {
        title: "Yuanqi Forest",
        text: `Founded in 2016, Yuanqi Forest is an innovative beverage brand independently developed and designed.In just 5 years, it has taken the lead in the sugar-free soft drink market and topped the "China Business News" gold signature carbonated drinks list. `,
        allText: `Founded in 2016, Yuanqi Forest is an innovative beverage brand independently developed and designed. In just 5 years, it has taken the lead in the sugar-free soft drink market and topped the "China Business News" gold signature carbonated drinks list. Its business not only covers the whole country, but also exports to more than 40 countries such as the United States, New Zealand, and Singapore. area.`,
      },
      item15: {
        title: "Bentley",
        text:
          "Bentley, a British luxury car brand, is headquartered in Crewe, England. In 1919, Mr. W.O. Bentley founded the Bentley Motor Company.",
        allText: `Bentley, a British luxury car brand, is headquartered in Crewe, England. In 1919, Mr. W.O. Bentley founded the Bentley Motor Company. "To build a fast car, a good car, the best in its class." was the founder Walter Irving Bentley Mr. initially pursued the ultimate and excellent car-making concept.`,
      },
      item16: {
        title: "Volkswagen",
        text:
          "Volkswagen is an automobile manufacturing company headquartered in Wolfsburg, Germany, and a core enterprise of the Volkswagen Group, one of the world's four largest automobile manufacturers. ",
        allText: `Volkswagen is an automobile manufacturing company headquartered in Wolfsburg, Germany, and a core enterprise of the Volkswagen Group, one of the world's four largest automobile manufacturers. In 2019, it ranked 9th in the Fortune Global 500. Volks means "national" in German, Wagen means "car" in German, and the full name means "national car", so it is often abbreviated as "VW". `,
      },
      item17: {
        title: "Treelab",
        text:
          "Treelab was founded in 2019. At first, the founding team found that businesses ranging from billions of dollars in revenue to individual stores were using manual or Excel to record management business. ",
        allText:
          "Treelab was founded in 2019. At first, the founding team found that businesses ranging from billions of dollars in revenue to individual stores were using manual or Excel to record management business. The birth of Treelab is to stimulate everyone's creativity, so that people who are not good at technology can flexibly build their own office tools according to their own business scenarios.",
      },
    },
  },
  "heigh-educate": {
    banner: {
      title: "Higher Education Press",
      subtitle:
        "Authing helps the higher education press build a smart identity platform to bring the most convenient, comfortable and suitable login experience to users.",
      brandDescript: `"Compared with many manufacturers, we can feel the advantages of Authing. It's a product made through thinking."`,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "//files.authing.co/authing-website/customer-intro-hep-en.png",
      descript1:
        "Founded in May 1954, the higher education press is one of the earliest professional education publishing institutions in New China. At present, the higher education society has more than 1700 employees, more than 10000 kinds of books published every year, and nearly 130 million copies issued. The scale of the publishing house and the number of employees are at the forefront of domestic publishing houses.",
      descript2:
        "Under the leadership of the Ministry of education, the higher education society undertakes the construction and operation of the national ideological and political work network of colleges and universities and China University Students online. At present, the ideological and political network has covered the education departments of provincial Party committees, 75 colleges and universities directly under the Ministry of Education, other ministries and universities, and 2500 local colleges and universities. The total number of online website members of Chinese college students has reached 11.2 million, a new record.",
      descript3:
        "The higher education society has carried out extensive cooperation with more than 200 institutions around the world, including many well-known publishers. 24 language versions of international products have been distributed in more than 60 countries in the world, and the number of copyright output has ranked among the top single publishing houses in China for years. It has been rated as a key national cultural export enterprise for many times.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The 35 million users of higher education society are distributed in dozens of software platforms, and its management is complex.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Higher education society needs an excellent user login experience to improve cooperation with the domestic education market and international publishers.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "To undertake the construction of Ideological and political networks means that fraud prevention and security are particularly important.",
      },
      item4: {
        title: "Challenge 4",
        description:
          "With the operation of Ideological and political networks, college student's online networks, higher education society has a strong demand for cross-brand single sign-on.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "Comfortable user experience",
        subtitle:
          "In cooperation with higher education society, the Authing team provides one-to-one consulting and technical services throughout the whole process to speed up the online website and support the success of customers.",
      },
      item2: {
        title: "Guarantee the security of enterprise identity information",
        subtitle:
          "By providing multi-factor authentication, login environment monitoring and other security technologies, Authing creates professional security protection for higher education society.",
      },
      item3: {
        title: "Perfect identity service",
        subtitle:
          "With the perfect identity authentication and access management services of Authing, the two engineers completed the deployment test in one afternoon, and easily integrated tens of millions of users of higher education society. Realize the experience of cross-brand login in one place and with one account.",
      },
      item4: {
        title: "Improve the scalability of the system",
        subtitle:
          "The Authing platform is flexible and rich in documents and software packages. In the rapid development of higher education society, provides the ability of expansion and integration, reduces daily maintenance, reduces the development cost in the future, creates an efficient and pleasant development mode, simplifies it management and accelerates business growth.",
      },
    },
  },
  cnpn: {
    banner: {
      title: "CNPN",
      subtitle:
        "Authing provides a perfect single sign-on platform to help PetroChina quickly realize efficient user management.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "//files.authing.co/authing-website/customer-intro-cnpn-en.png",
      descript1:
        "CNPC is an important state-owned backbone enterprise and one of the main oil and gas producers and suppliers in China. It is a comprehensive international energy company integrating oil and gas exploration and development, refining and chemical industry, sales and trade, pipeline storage and transportation, engineering technology, engineering construction, equipment manufacturing, and financial services. It occupies a leading position in domestic oil and gas exploration and development, and plays a leading role in the world 35 countries and regions carry out oil and gas business.",
      descript2:
        "In 2020, the company will rank third among the world's 50 major oil companies and fourth among Fortune's 500 major companies.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The Research Institute of PetroChina has a total of more than 1000 people and uses more than 10 software services, which makes it management complex.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "The company hopes that its members can log in to all software by using the company's account. However, the existing business system is old and difficult to innovate in security and authentication.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "The core function research and development itself has taken a long time, but the user verification function has not been improved. The company hopes to speed up the research and development cycle.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "Comfortable user experience",
        subtitle:
          "Authing provides a perfect single sign-on platform, which quickly realizes user authentication and access management functions for its web and app.",
      },
      item2: {
        title: "Guarantee the security of enterprise identity information",
        subtitle:
          "Authing provides a full set of C # SDKs to meet PetroChina's rapid access to its R & D system.",
      },
      item3: {
        title: "Perfect identity service",
        subtitle: `On the mobile terminal single sign-on, which is the focus of CNPC, Authing has the following features: automatic detection of login status of associated applications on the same device, and "arousing associated app to exchange user information", which facilitates CNPC to make choices based on scenarios.`,
      },
    },
  },
  dongnan: {
    banner: {
      title: "Southeast University",
      subtitle:
        "The five-element code helps Southeast University realize the single sign-on of cross-platform user system.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-dongnan-en.png",
      descript1: `Southeast University, located in Nanjing, the ancient capital of the Six Dynasties, is a famous institution of higher learning at home and abroad. The university is a national key university directly under the Ministry of education of the people's Republic of China and jointly built with Jiangsu Province. It is one of the key universities under the "985 Project" and "211 Project" of the people's Republic of China.`,
      descript2:
        "At present, Southeast University has 33 departments and 77 undergraduate majors, with 33 first-class doctoral degree authorization points and 49 first-class master degree authorization points. There are 30664 full-time students, including 16128 undergraduates and 14536 postgraduates, and 1989 international students, including 1547 international students with academic qualifications. The school has Sipailou, Jiulong Lake, Dingjiaqiao, and other campuses, covering an area of 5,888 acres, of which the Jiulong Lake campus is 3,752.35 acres, with a total construction area of about 789,700 square meters.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title:
          "Southeast University encountered the problem of single sign-on in the development of the BIM system. It needs to unite the self-developed system (BIM system) and the tripartite system (odoo, strapi, C9. IO) for unified authentication and authorization. However, the research and development of the BIM system itself are extremely complex. If the research and development of single sign-on are carried out at the same time, it will slow down the online speed of the project and ultimately affect the use of site staff. Also the BIM system has not only the web side but also the small program side. The research and development of multi-terminal and cross-platform user systems will introduce other complex problems. Besides, due to the complexity of BIM organization and the need for fine-grained authority classification, the research and development of a role-based authorization model will slow down the online speed of the system.",
        description: "",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing attaches importance to the education market, provides one-to-one consulting and technical services for Southeast University, accelerates its system to go online and supports business success.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing uses OAuth 2.0-based single sign-on scheme to connect BIM system with odoo, strapi and c9.io; uses RBAC-based authorization scheme to unify the authorization classification of organizations and staff; uses Cross-Platform SDK to realize cross-platform user system (including small programs) with five lines of code.",
      },
    },
  },
  "xian-gong": {
    banner: {
      title: "Xiangong intelligent",
      subtitle:
        "Authing provides a unified identity authentication platform to help enterprises manage user identity efficiently.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-xiangong-en.png",
      descript1:
        "Shanghai Xiangong Intelligent Technology Co., Ltd. (SEER) is a high-tech enterprise focusing on intelligent production and intelligent logistics. Its business covers various fields, such as General Amr controller, enterprise digital middle platform, vision system based cooperative solution of vehicle factory and automatic forklift AMR provides one-stop full perception logistics solutions for customers in various industries, supports non-standard applications with standard products, and is committed to promoting the transformation and upgrading of industrial informatization, digitization and intelligence.",
      descript2:
        "From discovering demand to solving demand, from solving demand to creating demand, SEER insists on seeking breakthrough between customer demand and its own multi-level demand, focusing on industrial intelligence, carrying out open innovation, and creating value for partners.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The user management ability of enterprise infrastructure platform is weak, at the same time, the technical means are relatively backward, the data between application systems are isolated from each other, the unified management can not be carried out, and the data island effect exists.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "With the development of business and the rapid increase of the number of employees, in the complex business scenarios and organizational structure, the authority management and allocation of internal employees has become a difficult problem.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "There is no unified identity authentication and authorization process among the internal systems of the enterprise. When users use the application system, they need to repeat the authentication and authorization process, which hinders the production efficiency and the user experience is poor.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Based on the cloud native Authing identity infrastructure platform, it helps enterprises complete the digital transformation and cloud identity integration, breaks the data island, and provides a standard and unified identity system for enterprises.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing is based on RBAC / ABAC privilege system model, which helps enterprises achieve efficient, flexible and fine-grained privilege management and allocation.",
      },
      item3: {
        title: "",
        subtitle:
          "Authing supports a variety of standard authentication and authorization protocols: oidc, oauth2, SAML, CAS, etc. through single sign on between applications, it realizes a unified authentication and authorization process and greatly improves the production efficiency of enterprises.",
      },
    },
  },
  deephow: {
    banner: {
      title: "Deephow",
      addtionTitle: "",
      subtitle: `Authing provides Deephow with a highly customized social login, providing its users with the most convenient third party login experience.`,
      brandDescript: ``,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-deephow-en.png",
      descript1:
        "Deephow develops an AI-powered learning platform for manufacturing, service, and repair, by turning real work into mobile ready, interactive smart video training.",
      descript2:
        "Deephow delivers a scalable solution to the skilled trade gap, using AI technology to capture and share knowledge across your organization effortlessly.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title:
          "Deephow needs an excellent social login experience to simplify its users' login experience on third-party platforms such as WeChat, win form, etc., and meanwhile provide its users with a simpler and more convenient way to create accounts on third-party platforms.",
        description: "",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "In cooperation with Deephow, Authing provides full one-to-one consultation and technical services to support Deephow's success.",
      },
      item2: {
        title: "",
        subtitle:
          "By using the C# SDK access method, Authing provides Deephow with a highly customizable social login, bringing its users a more convenient third-party account creation & login experience.",
      },
    },
  },
  theragun: {
    banner: {
      title: "THERAGUN",
      addtionTitle: "",
      subtitle:
        "Authing helps THERAGUN build an easy-to-use unified identity authentication platform, perfect seamless application docking, and improve user experience.",
      brandDescript: ``,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-theragun-en.png",
      descript1:
        "THERAGUN is the largest fascia gun brand in the United States, established in 2008. Its products use the original impact therapy to deeply massage the muscles, which can relieve muscle tension, accelerate recovery, and improve body functions. At the same time, it also provides users with topical products that soothe muscles and relieve pain.",
      descript2:
        "More than 250 professional sports teams (NFL, NBA, NHL, MLB, MLS, NASCAR) worldwide trust THERAGUN, which is also used by coaches, physiotherapists, chiropractors and the general public in more than 50 countries/regions.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title:
          "THERAGUN has used Shopify certification on their e-commerce website, but Shopify is not professional enough in identity authentication solutions. Taking into account the ease of use of the product, THERAGUN decided to adopt a more professional login solution to solve the complex login mode of the existing application system and achieve unified identity authentication.",
        description: "",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing provided THERAGUN with a new unified authentication system and completed the migration of all their customers in just 7 weeks, alleviating the pressure caused by a large number of customer logins and authentications.",
      },
      item2: {
        title: "",
        subtitle:
          "With Authing's comprehensive identity authentication and access management services, THERAGUN saved a total of about 600,000 US dollars in technical labor costs and saved nearly 50% of development man-hours.",
      },
    },
  },
  bentley: {
    banner: {
      title: "Bentley",
      addtionTitle: "",
      subtitle:
        "Authing provides a seamless, convenient and secure authentication experience for Bentley internal developers and external users to ensure the security of their login and identity verification.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-bentley-en.png",
      descript1:
        "Founded in 1984, Bentley Engineering Software Co., Ltd. has more than 4,000 employees, has branches in 172 countries around the world, and has annual revenues of more than 800 million U.S. dollars. It is rated as the world's second largest geographic information software solution provider.",
      descript2:
        "Bentley provides enterprises and professionals with solutions based on the design, construction and operation of roads, bridges, rail transit, water supply and drainage, public works and utilities, parks and industrial facilities.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "As a global company, Bentley has completed the establishment of an identity system globally, but the identity management products used at this stage cannot meet the needs of the rapid development of Bentley’s Chinese team’s business. The Chinese team hopes to seek a domestic An excellent identity authentication provider to quickly complete the integration of existing application systems and identities.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "With a single authentication access method, business security cannot be guaranteed. At present, Bentley China's business uses a single authentication method of username + password, security cannot be guaranteed, and some system password settings do not meet the password requirements, which poses security risks.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "The lack of clear real-time operations and security access audits cannot meet corporate security compliance requirements. With the rapid development of business, there is a lack of real-time and effective pre-warning, in-event auditing, and post-tracing paths for user access, permission usage, and data management.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing provides a complete single sign-on platform, and quickly implements efficient authentication and access management functions for its Web and employee systems.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing provides a variety of authentication methods Bentley options: combination, password policy, frequent login detection, custom authentication process, etc., and can be easily configured through the management console.",
      },
      item3: {
        title: "",
        subtitle:
          "Authing implements a visual security audit strategy for Bentley based on user behavior audit, administrator audit, and application access, and supports different personnel (groups) to set different password policies. Multi-factor authentication allows user access to be seamless, agile and secure.",
      },
    },
  },
  futu: {
    banner: {
      title: "Futu Niuniu",
      addtionTitle: "",
      subtitle:
        "Futu Niuniu uses Authing to implement secure corporate WeChat login and scan code authentication to ensure corporate information security",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "//files.authing.co/authing-website/customer-intro-futu-en.png",
      descript1:
        "Shenzhen Futu Network Technology Co., Ltd. was established in 2007. It is a strategic investment by Tencent and a subsidiary of NASDAQ-listed Futu Holdings (NASDAQ: FUTU). It is mainly engaged in the research and development of Internet technology products and provides services to individual investors. Market data, information, social networking and other services.",
      descript2:
        "Futu Securities and other US and Hong Kong stock brokers provide individual investors with US stocks, Hong Kong stocks, A-share stock trading, margin trading, wealth management and other services. The center builds a complete financial technology ecosystem that connects users, investors, companies, securities analysts, media, and opinion leaders.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "",
        description:
          "Futu Company uses both Tencent Enterprise WeChat and VooV Meeting internally for daily operation and management, hoping to log in to Tencent Meeting directly through Enterprise WeChat. However,  private information such as the email, and phone number will be directly exposed if the company's WeChat own application is directly authenticated, causing corporate security risks. In addition, it is necessary to ensure that the key information of the enterprise WeChat is safe and controllable, and cannot be stored on the public network or in a third-party environment.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Employees log in to the VooV meeting through the enterprise WeChat in Authing and enter the meeting according to the different organizational structures and permissions set in the enterprise WeChat.",
      },
      item2: {
        title: "",
        subtitle: `Bridge through the "Enterprise WeChat (third-party application) scan code login" function in Authing's IDaaS product, and use the OpenID Connection protocol to achieve enterprise WeChat scan code authentication.`,
      },
    },
  },
};
